export const removePrefix = (pattern, replaceWith = "") => (item) => item.replace(pattern, replaceWith).trim();
//# sourceMappingURL=remove-prefix.js.map